module.exports = __webpack_public_path__ + "static/media/color-vision-thumbnail.png";